import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import { toast } from "react-toastify";


// ----- Dummy Images for Category Step -----
const categories = [
  {
    label: "Learning Experience",
    value: "learning",
    image: "https://cdn-icons-png.flaticon.com/128/295/295128.png"
  },
  {
    label: "Experience",
    value: "experience",
    image: "https://cdn-icons-png.flaticon.com/128/3043/3043708.png"
  },
  {
    label: "Gears",
    value: "gears",
    image: "https://cdn-icons-png.flaticon.com/128/3909/3909310.png"
  },
  {
    label: "Growing Up",
    value: "growing_up",
    image: "https://cdn-icons-png.flaticon.com/128/1256/1256650.png"
  }
];

// ----- LOGO -----
const BuddyLogo = () => (
  <div style={{ marginBottom: 18 }}>
     <img src="/buddy_boonzie.svg" alt="Logo" className="navbar-logo-img" />
  </div>
);

// ----- STEP 1: AGE -----
const AgeStep = ({ age, setAge, onNext }) => (
  <div style={stepStyle}>
    <BuddyLogo />
    <h2 style={{
      fontFamily: "'Montserrat', Nunito, sans-serif",
      fontWeight: 500,
      fontSize: "1.23rem",
      color: "#181818",
      letterSpacing: ".15em",
      margin: "30px 0 28px"
    }}>
      How old is your kid?
    </h2>
    <input
      type="number"
      min="0"
      max="25"
      placeholder="AGE"
      value={age}
      onChange={e => setAge(e.target.value)}
      style={{
        display: "block",
        width: 250,
        margin: "0 auto 24px auto",
        padding: "14px",
        background: "#81c4f8",
        color: "#222",
        fontSize: "1.12rem",
        letterSpacing: ".14em",
        textAlign: "center",
        border: "none",
        borderRadius: 10,
        fontWeight: 600,
      }}
    />
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 70,    paddingRight: "200px", }}>
      <button
        disabled={!age}
        onClick={onNext}
        style={{
          marginLeft: 16,
          background: "none",
          border: "none",
          color: "#222",
       
          fontWeight: 700,
          letterSpacing: ".21em",
          fontSize: "1.08em",
          cursor: age ? "pointer" : "not-allowed"
        }}
      >
        NEXT
      </button>
      <button
        onClick={onNext}
        style={{
          marginLeft: 14,
          fontSize: ".97em",
          color: "#aaa",
          fontWeight: 500,
          border: "none",
          background: "none"
        }}
        type="button"
      >
        SKIP
      </button>
    </div>
  </div>
);

// ----- STEP 2: CATEGORY -----
const CategoryStep = ({ category, setCategory, onNext, onPrev }) => (
  <div style={stepStyle}>
    <BuddyLogo />
    <h2 style={{
      fontFamily: "'Montserrat', Nunito, sans-serif",
      fontWeight: 500,
      fontSize: "1.23rem",
      color: "#181818",
      letterSpacing: ".09em",
      margin: "30px 0 28px"
    }}>
      How can we help you?
    </h2>
    <div style={{
      display: "flex",
      gap: 26,
  
      justifyContent: "center",
      margin: "32px 0 38px"
    }}>
      {categories.map(cat => (
        <div
          key={cat.value}
          onClick={() => setCategory(cat.value)}
          style={{
            padding: "12px 10px 6px 10px",
            width: 300,
            height: 250,
            border: category === cat.value ? "3px solid #FFA74F" : "2px solid #FFAD5C",
            borderRadius: 17,
            textAlign: "center",
            background: category === cat.value ? "#FFF7F0" : "#fff",
            cursor: "pointer",
            boxShadow: category === cat.value ? "0 1px 10px #ffe3c3" : "none"
          }}
        >
          <img src={cat.image} alt={cat.label} style={{ width: 66, height: 66, marginBottom: "11px" }} />
          <div style={{
            fontFamily: "Nunito, sans-serif",
            fontWeight: 700,
            fontSize: ".92em",
            letterSpacing: ".11em",
            marginTop: 4,
            color: "#FFA259"
          }}>{cat.label.toUpperCase()}</div>
        </div>
      ))}
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <button
        onClick={onPrev}
        style={{
          marginRight: 18,
          background: "none",
          border: "none",
          color: "#aaa",
          fontWeight: 500,
          fontSize: ".97em",
          letterSpacing: ".11em",
          cursor: "pointer"
        }}>
        BACK
      </button>
      <button
        disabled={!category}
        onClick={onNext}
        style={{
          marginLeft: 10,
          background: "none",
          border: "none",
          color: "#222",
          fontWeight: 700,
          letterSpacing: ".21em",
          fontSize: "1.08em",
          cursor: category ? "pointer" : "not-allowed"
        }}
      >
        NEXT
      </button>
      <button
        onClick={onNext}
        style={{
          marginLeft: 14,
          fontSize: ".97em",
          color: "#aaa",
          fontWeight: 500,
          border: "none",
          background: "none"
        }}
        type="button"
      >
        SKIP
      </button>
    </div>
  </div>
);


const formLabel = {
  textAlign: "left",
  fontWeight: 700,
  fontSize: ".97em",
  letterSpacing: ".13em",
  margin: "15px 0 2px 2px"
};
const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  margin: "7px 0 0 0",
  padding: "11px 10px",
  borderRadius: "16px",
  border: "1.5px solid #FFAD5C",
  fontSize: "1.06em",
  letterSpacing: ".08em",
  background: "none",
  outline: "none"
};

const SignUpForm = ({ form, setForm, onBack }) => {
const navigate = useNavigate();
  const{googleLogin, setUser} = useAuth();


    const handleGoogleLogin = async (credentialResponse) => {
    try {
      const { credential } = credentialResponse;
      if (!credential) {
        alert("Google authentication failed.");
        return;
      }
      const result = await googleLogin(credential); // Auth context handles API call
      if (result && result.status === "success") {
        setUser(result.data); // Set user in context
        navigate("/dashboard/home");
      } else if (result && result.message) {
        alert(result.message || "Google login failed. Please try again.");
      }
    } catch (err) {
      console.error("Google login error:", err);
      alert("Google login failed. Please try again.");
    }
  };


  const handleChange = e => {
    const { name, type, value, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

const onSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    first_name: form.first_name,
    last_name: form.last_name,
    email: form.email_address,
    password: form.password,
    // ...other fields if needed
  };

  try {
    const response = await axios.post('/v1/auth/buddy/register', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Only 2xx status codes reach here:
    toast.success('Sign up successful! Please check your email for verification.');
    navigate("/");

  } catch (err) {
    if (err.response) {
      const { status, data } = err.response;
      if (status === 403) {
        toast.info(
          "We have your account already :) Please check your email for a verification link to activate your account before continuing."
        );
        navigate("/"); // or choose the right page
      } else if (status === 409) {
        toast.info(
          "A Buddy account with this email already exists. Please log in to continue."
        );
        navigate("/login");
      } else {
        toast.error(data?.message || 'Sign up failed. Please try again.');
      }
    } else {
      // Network or config error
      toast.error('An error occurred. Please try again later.');
    }
    console.error(err);
  }
};



  return (
    <div style={stepStyle}>
      <BuddyLogo />
      <div style={{
        fontFamily: "'Montserrat', Nunito, sans-serif",
        fontWeight: 500,
        fontSize: "1.18rem",
        color: "#2d2d2d",
        marginBottom: 7,
      }}>
        Set up your profile and
      </div>
      <div style={{
        fontFamily: "Nunito, sans-serif",
        fontWeight: 400,
        fontSize: "1.14rem",
        color: "#282828",
        marginBottom: 28,
        letterSpacing: "0.07em"
      }}>
        we&#39;ll handle the magic behind the scenes.
      </div>
      {/* Google button */}
       <div className="googlebtn">
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <div>
              <GoogleLogin
                onSuccess={handleGoogleLogin}
                onError={() => {
                  console.log("Google Login Failed");
                  alert("Google Login Failed");
                }}
              />
            </div>
          </GoogleOAuthProvider>
        </div>
      <div style={{
        color: "#AAA",
        fontWeight: 600,
        fontSize: "0.93rem",
        margin: "6px 0 10px 0",
        letterSpacing: ".16em"
      }}>
        OR
      </div>
      <form onSubmit={onSubmit}>
        <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
          <div style={{ flex: 1 }}>
            <div style={formLabel}>FIRST NAME</div>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              style={inputStyle}
              autoComplete="given-name"
            />
          </div>
          <div style={{ flex: 1 }}>
            <div style={formLabel}>LAST NAME</div>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              style={inputStyle}
              autoComplete="family-name"
            />
          </div>
        </div>
        <div>
          <div style={formLabel}>EMAIL ADDRESS</div>
          <input
            type="email"
            name="email_address"
            value={form.email_address}
            onChange={handleChange}
            style={inputStyle}
            autoComplete="email"
            required
          />
        </div>
        <div>
          <div style={formLabel}>PASSWORD</div>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            style={inputStyle}
            required
            autoComplete="new-password"
          />
        </div>
        <div style={{ textAlign: "left", margin: "3px 0 17px 2px" }}>
          <label style={{ fontSize: "0.95em" }}>
            <input
              type="checkbox"
              name="promo_opt_in"
              checked={form.promo_opt_in}
              onChange={handleChange}
              style={{ marginRight: 7 }}
            />
            I’d like to receive promotional offers and updates from approved Buddy partners.
          </label>
        </div>
        <button
          type="submit"
          style={{
            width: "96%",
            maxWidth: 370,
            borderRadius: "24px",
            background: "#FFA357",
            color: "#313131",
            fontWeight: 800,
            fontSize: "1.24rem",
            letterSpacing: ".19em",
            border: "2px solid #A96E2F",
            padding: "12px 0 12px 0",
            marginTop: 14,
            marginBottom: 7,
            cursor: "pointer",
            boxShadow: "0 4px 24px #eee"
          }}
        >
          SIGN UP
        </button>
        <div style={{ fontSize: ".9em", color: "#777", margin: "14px 0 3px", lineHeight: 1.6 }}>
          Your registry is private until you choose to share it.
          <br />
          By clicking Sign Up you agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">B.Buddy Terms</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </div>
        <div style={{ textAlign: "right", marginTop: "28px" }}>
          <button
            onClick={e => { e.preventDefault(); onBack(); }}
            style={{
              background: "none",
              border: "none",
              color: "#aaa",
              fontWeight: 500,
              fontSize: ".97em",
              letterSpacing: ".11em",
              cursor: "pointer"
            }}>
            BACK
          </button>
        </div>
      </form>
    </div>
  );
};

// ----- MASTER COMPONENT -----
export default function BuddySignUpWizard() {

  const {googleLogin} = useAuth();
  const [step, setStep] = useState(0); // 0: Age, 1: Category, 2: Signup
  const [age, setAge] = useState("");
  const [category, setCategory] = useState("");
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    password: "",
    promo_opt_in: false
  });

  return (
    <div
      style={{
        background: "#fff",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Nunito, sans-serif",
        position: "relative"
      }}
    >
      <div
        style={{
          background: "#fff",
 

          width: "95%",
          borderRadius: 10,
          padding: "48px 40px 26px 40px",
          position: "relative",
          overflow: "hidden",
          minHeight: 440
        }}
      >
        {/* Top orange shape */}
        <div
          aria-hidden
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 170,
            height: 160,
            background: "#FFA357",
            borderBottomLeftRadius: 80,
            zIndex: 0
          }}
        />
        {/* Stepper */}
        <div style={{ zIndex: 2, position: "relative" }}>
          {step === 0 && <AgeStep age={age} setAge={setAge} onNext={() => setStep(1)} />}
          {step === 1 && (
            <CategoryStep
              category={category}
              setCategory={setCategory}
              onNext={() => setStep(2)}
              onPrev={() => setStep(0)}
            />
          )}
          {step === 2 && (
            <div style={{ maxWidth: 500 , margin: "0 auto" }}>

            <SignUpForm
              
              form={form}
              setForm={setForm}
              onBack={() => setStep(1)}
            />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const stepStyle = {
  margin: "0 auto",
  textAlign: "center",

  minHeight: 350
};
